import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-layout',
  templateUrl: './web-layout.component.html',
  styleUrls: ['./web-layout.component.css']
})
export class WebLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
